module.exports = __webpack_public_path__ + "static/Slack-233b7d07a0264486343f89e1b54139f9.jpg";